import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconCircleBooleanFalse = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12.7666" r="12" fill="#FFEEEE"/>
            <path d="M15.697 15.383C15.9611 15.6414 15.9611 16.0433 15.697 16.3017C15.5649 16.4309 15.4035 16.4883 15.2274 16.4883C15.0514 16.4883 14.8899 16.4309 14.7579 16.3017L12.0726 13.6748L9.38723 16.3017C9.25516 16.4309 9.09375 16.4883 8.91766 16.4883C8.74158 16.4883 8.58016 16.4309 8.4481 16.3017C8.18397 16.0433 8.18397 15.6414 8.4481 15.383L11.1334 12.7561L8.4481 10.1291C8.18397 9.87072 8.18397 9.46878 8.4481 9.21039C8.71223 8.952 9.1231 8.952 9.38723 9.21039L12.0726 11.8373L14.7579 9.21039C15.022 8.952 15.4329 8.952 15.697 9.21039C15.9611 9.46878 15.9611 9.87072 15.697 10.1291L13.0117 12.7561L15.697 15.383Z"
                  fill={color}/>
        </svg>


    </div>
);

export default IconCircleBooleanFalse;
